import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import Button from "../../../components/shared/components/button/Button.style";
import tagsImage from "../../../assets/svg/tagsImage.svg";
import excelImage from "../../../assets/svg/ExcelFileImage.svg";
import audinceImage from "../../../assets/svg/AudinceImage.svg";

// New Design System Components
import {
  WizardHeader,
  WizardTitle,
  WizardSubtitle,
  WizardGrid,
  WizardCard,
  WizardIllustration,
  WizardCardTitle,
  WizardCardDescription,
  BackLink,
  CampaignsContainer,
} from "./Campaigns.style";

const BroadcastType = () => {
  const history = useHistory();
  const channelId = useSelector((state) => state.campaign.create.channelId);

  useEffect(() => {
    if (!channelId) history.push("/broadcast/table");
  }, [channelId]);

  return (
    <CampaignsContainer>
      <BackLink onClick={() => history.push("/broadcast/table")}>
        ← Regresar al listado
      </BackLink>

      <WizardHeader>
        <WizardTitle>Nueva Campaña</WizardTitle>
        <WizardSubtitle>¿Cómo deseas cargar los contactos para este envío?</WizardSubtitle>
      </WizardHeader>

      <WizardGrid>
        {/* Excel File Option */}
        <WizardCard onClick={() => history.push("/broadcast/file")}>
          <WizardIllustration>
            <img src={excelImage} alt="Excel" />
          </WizardIllustration>
          <WizardCardTitle>Archivo Excel</WizardCardTitle>
          <WizardCardDescription>
            Sube un archivo .xlsx o .csv con tu base de datos de contactos personalizada.
          </WizardCardDescription>
          <Button designV4 style={{ width: '100%', marginTop: 'auto' }}>
            Elegir
          </Button>
        </WizardCard>

        {/* Audience Option - Disabled */}
        <WizardCard disabled>
          <WizardIllustration>
            <img src={audinceImage} alt="Audiencia" />
          </WizardIllustration>
          <WizardCardTitle>Audiencia</WizardCardTitle>
          <WizardCardDescription>
            Selecciona una audiencia guardada o un segmento inteligente de tu CRM.
          </WizardCardDescription>
          <Button
            designV4
            disabled
            style={{ width: '100%', marginTop: 'auto', opacity: 0.5 }}
          >
            Próximamente
          </Button>
        </WizardCard>

        {/* Tags Option */}
        <WizardCard onClick={() => history.push("/broadcast/tags")}>
          <WizardIllustration>
            <img src={tagsImage} alt="Etiquetas" />
          </WizardIllustration>
          <WizardCardTitle>Etiqueta(s)</WizardCardTitle>
          <WizardCardDescription>
            Filtra tus contactos actuales usando una o varias etiquetas asignadas.
          </WizardCardDescription>
          <Button designV4 style={{ width: '100%', marginTop: 'auto' }}>
            Elegir
          </Button>
        </WizardCard>
      </WizardGrid>
    </CampaignsContainer>
  );
};

export default BroadcastType;
